import React from 'react';

interface SupportFeedBackPopupProps {
}

const SupportFeedBackPopup: React.FC<SupportFeedBackPopupProps> = () => {

    return (
      <>
        <div className="modal fade" id="feedback-popup" data-backdrop="static" data-keyboard="false" aria-hidden="true">
            <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content py-5 px-3 mt-4">
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span>Close</span>
                        <img src="https://www.nowtv.now.com/wp-content/themes/wmx/images//icons/mw-remove.png" alt="" />
                    </button>
                    <div className="modal-body text-center pb-5 px-lg-5 px-0">
                        <div className="intro-for-yes hide-me mb-5" style={{display: "none"}}>
                            <h2>Great! We’re happy to have helped.</h2>
                            <p>
                                <span style={{fontFamily: "Barlow"}}>
                                    Other Feedback? We’d be happy to hear! (Please note this is not an enquiry channel. For technical support you may email us at 
                                    <span style={{color: "#ff9900"}}>
                                        <a style={{color: "#ff9900"}} href="mailto:ts@nowtv.now.com">ts@nowtv.now.com</a>
                                    </span>
                                    , or contact us through one of the channels listed 
                                    <span style={{color: "#ff9900"}}>
                                        <a style={{color: "#ff9900"}} href="https://www.nowtv.now.com/contact-us/" target="_blank" rel="noopener">here</a>
                                    </span>.)
                                </span>
                            </p>
                        </div>
                        <div className="intro-for-no hide-me mb-5" style={{display: "none"}}>
                            <h3>Please let us know what was missing.</h3>
                            <p>
                                <span style={{fontFamily: "Barlow"}}>
                                    Your input helps us improve our support pages and the overall Now TV experience. Thank you! (Please note this is not an enquiry channel. For technical support you may email us at 
                                    <a href="mailto:ts@nowtv.now.com">
                                        <span style={{color: "#ff9900"}}>ts@nowtv.now.com</span>
                                    </a>
                                    , or contact us through one of the channels listed 
                                    <span style={{color: "#ff9900"}}>
                                        <a style={{color: "#ff9900"}} href="https://www.nowtv.now.com/contact-us/" target="_blank" rel="noopener">here</a>
                                    </span>.)
                                </span>
                            </p>
                        </div>
                        <form className="barlow-font mx-auto feedback-form" action="#thank-you" method="POST" style={{maxWidth: "460px"}}>
                            <input type="hidden" name="useful" value="Yes" />
                            <div className="form-group position-relative">
                                <textarea name="message" className="bordered-input mb-0" required data-error="Please input your message"></textarea>
                                <span className="input-legend">Message (Mandatory)</span>
                            </div>
                            <div className="form-group position-relative">
                                <input type="hidden" name="postid" value="3511" />
                                <input type="text" name="commentor_name" className="bordered-input" />
                                <span className="input-legend">Name (Optional)</span>
                            </div>
                            <div className="form-group position-relative mb-0">
                                <input type="email" name="email_address" className="bordered-input" />
                                <span className="input-legend">Email (Optional)</span>
                            </div>
                            <div className="text-center pb-5 pt-3">
                                <button type="submit" name="submit" className="default-btn mini">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
      </>
    );
};

export default SupportFeedBackPopup;